import { api } from '../axios'
import type { ApiResponse, Subject } from '../../../types'

export const subjectsApi = {
  getAll: () =>
    api.get<ApiResponse<Subject[]>>('/subjects'),

  getById: (id: number) =>
    api.get<ApiResponse<Subject>>(`/subjects/${id}`),

  create: (data: Subject) =>
    api.post<ApiResponse<Subject>>('/subjects', data),

  update: (id: number, data: Partial<Subject>) =>
    api.put<ApiResponse<Subject>>(`/subjects/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/subjects/${id}`),
}

